export const lahoreAreas = [
  "Johar Town", "DHA Defence", "Allama Iqbal Town", "Cantt", "Gulberg", "Bahria Town",
  "Al Faisal Town", "Al Rehman Garden", "Askari XI", "Askari-XI", "Awan Town", "Baghban Pura",
  "Bahria Orchard", "Bedian Road", "Bhatta Chowk", "Bismillah Housing Scheme", "College Road",
  "Canal Bank Housing Scheme", "Canal Garden", "Canal View", "Cavalry Ground", "Central Park Housing Scheme",
  "Chauburji Park", "China Scheme", "Chungi Amar Sadhu", "DHA Phase 1", "DHA Phase 2", "DHA Phase 3",
  "DHA Phase 4", "DHA Phase 5", "DHA Phase 6", "DHA Phase 7", "DHA Phase 8", "DHA Rehbar",
  "Darogawala", "EME Society", "Faisal Town", "Ferozepur Road", "Gajju Matah", "Garden Town", "Ghazi Road",
  "Green Town", "Gulshan Ravi", "HBFC Housing Society", "Harbans Pura", "IEP Engineers Town", "Ichhra", "Izmir Town",
  "Jail Road", "Kahna", "Khayaban-e-Amin", "Kot Lakhpat", "LDA Avenue", "Lahore Medical Housing Society",
  "Lake City", "Lawrence Road", "Mall Road", "Manawan", "Manga Mandi", "Marghzar Officers Colony",
  "Maulana Shaukat Ali Road", "Model Town", "Mughal Pura", "Nasheman-e-Iqbal", "New Muslim Town",
  "PCSIR Phase 2", "PCSIR Staff Colony", "PIA Housing Scheme", "Pak Arab Housing Society", "Paragon City",
  "Park View", "Park View Villas", "Punjab Co-operative Housing Society", "Queens Road", "Raiwind Road", "Sabzazar Scheme",
  "Samanabad", "Shadbagh", "Shahdara", "Shalimar Link Road", "State Life Housing Society", "Taj Bagh",
  "Thokar Niaz Baig", "Township", "Upper Mall", "Valencia Housing Society", "Wahdat Road", "Walton Road", "Wapda Town"
];

export const cityAreasMap = {
  "Lahore": lahoreAreas,
  // Add more cities as needed
};
